import React from "react";
import {observer} from "mobx-react-lite";
import {FormActive} from "@/types/login-form-active";

import {BodyLogin, Container, FooterLogin, Gradient, HeaderLogin, ClickSpan, Divs} from "@/components";
import {useObserveFormActive} from "@/pages/login/hooks";
import {FormLogin, RegDataForm, EmailForm, FormCode, FormPassword} from "./forms";
import {useStore} from "@/store";


const FooterAction = observer(() => {
    const {
        formActiveStore: {formActive, setFormActive},
    } = useStore()
    switch (formActive) {
        case FormActive.Login:
            return (
                <>
                    <ClickSpan $reg={true} onClick={() => setFormActive(FormActive.RegData)}>
                        Зарегистрироваться
                    </ClickSpan>
                    <Divs count={2}/>
                    <ClickSpan onClick={() => setFormActive(FormActive.Email)}>Не помню пароль</ClickSpan>
                </>
            )
        default:
            return (
                <ClickSpan onClick={() => setFormActive(FormActive.Login)}>
                    Отмена
                </ClickSpan>
            )
    }
});


const BodyForm = observer(() => {

    const {formActiveStore: {formActive}} = useStore()

    switch (formActive) {
        case FormActive.Login:
            return <FormLogin/>
        case FormActive.RegData:
            return <RegDataForm/>
        case FormActive.Email:
            return <EmailForm/>
        case FormActive.Code:
            return <FormCode/>
        case FormActive.Password:
            return <FormPassword/>
    }
});


const Login = observer(() => {
    useObserveFormActive();
    return (
        <Container>
            <Divs count={4}/>
            <div>
                <HeaderLogin>
                    <Gradient> Cloud </Gradient>
                    <Gradient> CASH MANAGEMENT </Gradient>
                </HeaderLogin>
                <BodyLogin> <BodyForm/> </BodyLogin>
                <FooterLogin>
                    <div/>
                    <FooterAction/>
                    <Divs count={2}/>
                </FooterLogin>
            </div>
        </Container>
    );
})

export default Login;